import { gSP } from "app/blitz-server"
import SplashLayout from "app/core/layouts/Splash"

import { ContactForm } from "app/contentful/ContactForm"
import Footer from "app/splash/components/Footer"
import Header from "app/splash/components/Header"
import { Campaigns } from "app/splash/components/splash-sections/Campaigns"
import { Customers } from "app/splash/components/splash-sections/Customers"
import { Investors } from "app/splash/components/splash-sections/Investors"
import { Pricing } from "app/splash/components/splash-sections/Pricing"
import { Reviews } from "app/splash/components/splash-sections/Reviews"
import { Templates } from "app/splash/components/splash-sections/Templates"
import { Triggers } from "app/splash/components/splash-sections/Triggers"
import contentful from "integrations/contentful"
import { useEffect, useState } from "react"

const Page = ({ page }: { page: any }) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
    return () => {
      // on unmount
      setLoaded(false)
    }
  }, [])

  return (
    <>
      <Header showBookDemo={false} />
      <main className="mx-auto relative pt-[85px] overflow-hidden px-[16px] md:px-5">
        <div className="relative">
          <ContactForm page={page} />
        </div>
        <Customers animateOnScroll={false} />
        <Pricing />
        <Campaigns />
        <Reviews />
        <Triggers />
        <Templates />
        <Investors />
      </main>
      <Footer />
    </>
  )
}

Page.suppressFirstRenderFlicker = true
Page.getLayout = (page) => <SplashLayout title="Superwall">{page}</SplashLayout>

export const getStaticProps = gSP(async function getStaticProps({ params }) {
  const slug = params?.post as string

  const page = await contentful.getPageBySlug(slug)

  return {
    props: {
      page,
    },
    revalidate: 10,
  }
})

export async function getStaticPaths() {
  const slugs = await contentful.getPostSlugs()

  return {
    paths: slugs.map((slug) => {
      return {
        params: {
          page: slug,
        },
      }
    }),
    fallback: "blocking",
  }
}

export default Page
function pressNavLink(arg0: string): void {
  throw new Error("Function not implemented.")
}
